import React from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { DataModelWithCubes } from "../../components/detail/DataModelWithCubes";

const ResultsCubesComponent = ({ dataModelsWithCubes, maintenanceAgency }) => {
  return dataModelsWithCubes.length === 0 ? (
    <div>There are no cubes satisfying the search criteria.</div>
  ) : (
    <div className="ResultsCubes results-list">
      {dataModelsWithCubes.map((dataModel) => (
        <div
          className={`MultiSearchPage__result-row row ${maintenanceAgency}`}
          key={`${dataModel.framework.code}_${dataModel.tid}`}
        >
          <div className="col-xs-2">
            {dataModel.framework.code ? (
              <div>
                <Link
                  to={`/view/${dataModel.framework.type}/${dataModel.framework.tid}`}
                  target="_blank"
                >
                  {dataModel.framework.name || dataModel.framework.code}
                </Link>
              </div>
            ) : (
              <div>No framework</div>
            )}
            {/* let's ignore frameworks reachable from data models under DATA_MODELS_FRAMEWORKS for now */}
          </div>
          <div className="col-xs-10">
            <DataModelWithCubes
              dataModelInfo={dataModel}
              dataModelCubes={dataModel.cubes}
              initialExpanded={dataModel.tid === undefined}
              includesCubesWithHierarchies={true}
              openLinksInNewTabs={true}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export const ResultsCubes = observer(ResultsCubesComponent);
